import { useDispatch } from 'react-redux'
import { useCancelToken } from 'utils/hooks/useCancelToken'
import {
  CHANGE_ACTIVE_WALLET_ID,
  FETCH_EXPIRED_PAYMENTS,
  FETCH_WALLET_PROMISED_PAYMENTS,
  FETCH_WALLET_TRANSACTIONS,
  FETCH_WALLETS,
  RESET_WALLET_TRANSACTIONS,
  RESET_WALLETS,
} from 'modules/Finance/Wallets/types'

export const useWalletsActions = () => {
  const dispatch = useDispatch()
  const { cancelableDispatch } = useCancelToken()

  const getWallets = () => {
    dispatch({ type: FETCH_WALLETS })
  }

  const setActiveWalletID = (props) => {
    dispatch({ type: CHANGE_ACTIVE_WALLET_ID, payload: props })
  }

  const getPromisedPayments = () => {
    cancelableDispatch({ type: FETCH_WALLET_PROMISED_PAYMENTS })
  }

  const getWalletTransactions = (props) => {
    cancelableDispatch({ type: FETCH_WALLET_TRANSACTIONS, payload: props })
  }

  const resetWallets = () => {
    dispatch({ type: RESET_WALLETS })
  }

  const resetTransactions = () => {
    dispatch({ type: RESET_WALLET_TRANSACTIONS })
  }

  const fetchExpiredPromisedPayments = (props) => {
    dispatch({ type: FETCH_EXPIRED_PAYMENTS, payload: props })
  }

  return {
    getWallets,
    setActiveWalletID,
    getPromisedPayments,
    fetchExpiredPromisedPayments,
    getWalletTransactions,
    resetWallets,
    resetTransactions,
  }
}
